<template>
    <a :title="title" class="theme-box">
        <div class="theme-title">
            <h6 class="text-truncate">{{ number }}. {{ title }}</h6>
            <img src="@assets/img/right-arrow-bi.svg" width="20px">
        </div>
    </a>
</template>

<script>
export default {
    name: "ThemeBox",
    props: {
        number: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.theme-box {
    background-color: $medium-gray;
    padding: 20px;
    border-radius: 10px;
    display: block;
    cursor: pointer;

    @media (max-width: $md) {
        margin-bottom: 10px;
    }

    .theme-title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h6 {
            margin-bottom: 0;
            color: white;
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
        }

        img {
            margin-left: 10px;
        }
    }
}
</style>
